import React from "react";

const IFRAME_FPO_ASPECT_RATIO = "600 / 399";
const IFRAME_FPO_YELLOW = "#FFB900";

export const IframeFpoThumbnail: React.FC = () => (
  <div
    className="iframe-fpo-thumbnail"
    style={{
      position: "relative",
      width: "100%",
      aspectRatio: IFRAME_FPO_ASPECT_RATIO,
    }}
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 600 399"
      preserveAspectRatio="xMidYMid meet"
      aria-hidden
      style={{ width: "100%", height: "100%", display: "block" }}
    >
      <rect width="600" height="399" fill={IFRAME_FPO_YELLOW} />

      <rect
        x="238.5"
        y="154.5"
        width="123"
        height="92"
        fill="none"
        stroke="#FFFFFF"
        strokeWidth="11"
      />

      <rect x="284" y="174" width="31" height="5" fill="#FFFFFF" />

      <rect x="279" y="185" width="41" height="4" fill="#FFFFFF" />

      <rect
        x="276"
        y="199"
        width="46"
        height="24"
        rx="4"
        fill="none"
        stroke="#FFFFFF"
        strokeWidth="6"
      />
    </svg>
  </div>
);
